// Modern Wallet Service using Wagmi and Reown AppKit
// Follows React development best practices

import { createConfig, http } from 'wagmi'
import { bsc, bscTestnet } from 'wagmi/chains'
import { metaMask, walletConnect } from 'wagmi/connectors'

// Get project ID from environment
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID

// Configure chains
export const chains = [bsc]

// Configure connectors
export const connectors = [
  metaMask({
    dappMetadata: {
      name: 'Bomberman Game',
      url: typeof window !== 'undefined' ? window.location.origin : 'https://localhost:5173',
    },
  }),
  walletConnect({
    projectId,
    metadata: {
      name: 'Bomberman Game',
      description: 'Multiplayer Bomberman Game',
      url: typeof window !== 'undefined' ? window.location.origin : 'https://localhost:5173',
      icons: ['https://avatars.githubusercontent.com/u/179229932']
    },
  }),
]

// Create wagmi config
export const config = createConfig({
  chains,
  connectors,
  transports: {
    [bscTestnet.id]: http(),
    [bsc.id]: http(),
  },
  ssr: true,
})

// Network configurations for UI
export const networkConfigs = {
  [bscTestnet.id]: {
    name: 'BSC Testnet',
    symbol: 'tBNB',
    color: '#F3BA2F',
    icon: 'T',
    isTestnet: true,
    chainId: bscTestnet.id,
  },
  [bsc.id]: {
    name: 'BSC Mainnet',
    symbol: 'BNB',
    color: '#F3BA2F',
    icon: 'M',
    isTestnet: false,
    chainId: bsc.id,
  },
}

// Utility functions
export const getNetworkConfig = (chainId) => {
  return networkConfigs[chainId] || {
    name: 'Unknown Network',
    symbol: 'ETH',
    color: '#666',
    icon: '?',
    isTestnet: false,
    chainId,
  }
}

// Format address for display
export const formatAddress = (address) => {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

// Check if MetaMask is installed
export const isMetaMaskInstalled = () => {
  return typeof window !== 'undefined' && typeof window.ethereum !== 'undefined'
}

// Get available networks
export const getAvailableNetworks = () => {
  return Object.values(networkConfigs)
}

// Default export for backward compatibility
const walletService = {
  config,
  chains,
  connectors,
  networkConfigs,
  getNetworkConfig,
  formatAddress,
  isMetaMaskInstalled,
  getAvailableNetworks,
}

export default walletService